const isSuperUser = 'super_user';

const viewCustomNotifications = 'view_custom_notifications';
const editCustomNotifications = 'edit_custom_notifications';

const viewCards = 'view_cards';
const editCards = 'edit_cards';

const viewDefaultCardLink = 'view_default_card_link';
const editDefaultCardLink = 'edit_default_card_link';

const viewReferralCardLink = 'view_refferal_card_link';
const editReferralCardLink = 'edit_refferal_card_link';

const viewAwards = 'view_awards';
const editAwards = 'edit_awards';

const viewUsers = 'view_users';
const editUsers = 'edit_users';

const viewUserAwayzAccess = 'view_user_awayz_access';
const editUserAwayzAccess = 'edit_user_awayz_access';

const viewUserSource = 'view_user_source';
const editUserSource = 'edit_user_source';

const viewUserRoles = 'view_user_roles';
const editUserRoles = 'edit_user_roles';

const viewFaqs = 'view_faqs';
const editFaqs = 'edit_faqs';

const viewReports = 'view_reports';
const exportReports = 'export_reports';

const viewSubscription = 'view_subscription';
const editSubscription = 'edit_subscription';

const viewReportRevenueSharedPartner = 'view_report_revenue_shared_partner';
const exportReportRevenueSharedPartner = 'export_report_revenue_shared_partner';

const viewDataComparison = 'view_data_comparison';
// const editDataComparison= 'edit_data_comparison';

const viewBulkCSVUpload = 'view_bulk_csv_upload';
// const editBulkCSVUpload= 'edit_bulk_csv_upload';

const userPermissions = [
  {
    label: 'Super User Access',
    view: isSuperUser
  },
  {
    label: 'Custom Notifications',
    view: viewCustomNotifications,
    edit: editCustomNotifications
  },
  {
    label: 'Cards',
    view: viewCards,
    edit: editCards,
    nested_permissions: [
      {
        label: 'Default Card Links',
        view: viewDefaultCardLink,
        edit: editDefaultCardLink
      },
      {
        label: 'Referral Card Links',
        view: viewReferralCardLink,
        edit: editReferralCardLink
      }
    ]
  },
  {
    label: 'Subscriptions',
    view: viewSubscription,
    edit: editSubscription
  },
  {
    label: 'Awards',
    view: viewAwards,
    edit: editAwards
  },
  {
    label: 'Users',
    view: viewUsers,
    edit: editUsers,
    nested_permissions: [
      {
        label: 'User Awayz Access',
        view: viewUserAwayzAccess,
        edit: editUserAwayzAccess
      },
      {
        label: 'User Source',
        view: viewUserSource,
        edit: editUserSource
      }
    ]
  },
  {
    label: 'User Roles',
    view: viewUserRoles,
    edit: editUserRoles
  },
  {
    label: 'FAQs',
    view: viewFaqs,
    edit: editFaqs
  },
  {
    label: 'Reports',
    view: viewReports,
    edit: exportReports,
    nested_permissions: [
      {
        label: 'Revenue shared partner report',
        view: viewReportRevenueSharedPartner,
        edit: exportReportRevenueSharedPartner
      }
    ]
  },
  {
    label: 'Data Comparison',
    view: viewDataComparison
  },
  {
    label: 'Bulk CSV Upload',
    view: viewBulkCSVUpload
  }
];

export {
  isSuperUser,
  userPermissions,
  viewCustomNotifications,
  editCustomNotifications,
  viewCards,
  viewDefaultCardLink,
  editDefaultCardLink,
  viewReferralCardLink,
  editReferralCardLink,
  editCards,
  viewAwards,
  editAwards,
  viewUsers,
  editUsers,
  viewUserAwayzAccess,
  editUserAwayzAccess,
  viewUserSource,
  editUserSource,
  viewUserRoles,
  editUserRoles,
  viewFaqs,
  editFaqs,
  viewReports,
  exportReports,
  viewReportRevenueSharedPartner,
  exportReportRevenueSharedPartner,
  viewDataComparison,
  viewBulkCSVUpload,
  viewSubscription,
  editSubscription
};
